import { requestHandler } from "../lib/utils/network-client";

export function getDepartments(params = {}) {
  return requestHandler("/departments", {
    params
  });
}

export function getDepartmentById(id) {
  return requestHandler(`/departments/${id}`);
}

export function createDepartment(payload) {
  return requestHandler("/departments", {
    method: "POST",
    body: payload
  });
}

export function updateDepartment(id, payload) {
  return requestHandler(`/departments/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteDepartment(id) {
  return requestHandler(`/departments/${id}`, {
    method: "DELETE"
  });
}
